import cookie from 'isomorphic-cookie'
import type { NextRouter } from 'next/router'

import { cookieNames } from '~/utils/constants'
import redirectTo from '~/utils/redirect-to'

export const useTextContent = (opts: { isLoggedIn: boolean; router: NextRouter; onStartReview: () => void }) => {
  if (!opts.isLoggedIn) {
    return {
      buttonAction: 'Inicia sesión para escribir una reseña',
      label: 'Inicia sesión y sé el primero en compartir tu opinión.',
      onClick: () => {
        cookie.save(cookieNames.CALLBACK_URL, opts.router.asPath, { secure: false })

        return redirectTo('/ingresar')
      },
    }
  }

  return {
    buttonAction: 'Escribe una reseña',
    label: 'Sé el primero en compartir tu opinión.',
    onClick: () => {
      opts.onStartReview()
    },
  }
}
